import { Pipe, PipeTransform, inject } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { CalculatedOdds, Odds } from './odds';
import { OddsFormatterService } from './odds-formatter.service';

@Pipe({
    name: 'bsOddsFormatter',
    standalone: true,
})
export class OddsFormatterPipe implements PipeTransform {
    formatterService = inject(OddsFormatterService);

    transform(
        odds: Odds | CalculatedOdds | null | undefined,
        displayFormat: OddsDisplayFormat,
        cutZero: boolean = false,
        isSummary: boolean = false,
        fromFormat: OddsDisplayFormat | undefined = undefined,
        maxDecimalPlaces: number = 3,
        useOddsMultiplicationFormat: boolean = false, //everytime we pass the result of a multiplication in case of UK odds, we should show the odds in '{decimal}/1' format; this flag is passed to understand which odds are multiplication results - used for summary, oddsBoost, others?; normally we should NOT have such flag, if ComputedOdds are passed then use this format
    ): string {
        return this.formatterService.format(odds, {
            displayFormat,
            cutZero,
            isSummary,
            maxDecimalPlaces,
            useOddsMultiplicationFormat,
            fromFormat,
        });
    }
}
